import React from "react";
import Submission from "../../submission";

interface TabHistoryProps {
  taskDetail: any;
}

const TabHistory: React.FC<TabHistoryProps> = ({ taskDetail }) => {
  return (
    <div style={{ padding: "20px 0" }}>
      <Submission task_id={taskDetail[0]?.task_id} />
    </div>
  );
};

export default TabHistory;
